import AddComment from './add-comment';
import {ALERT_WARNING__16} from '@homeaway/svg-defs';
import CommentsList from './comments-list';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {graphql} from 'react-apollo';
import React, {Component} from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {withAuth} from '../../../components/auth';
import {withTranslationsAsProps} from '../../../components/translations';
import {
    GET_NOTES,
    mapStateToProps,
    POLL_INTERVAL,
    pollingOptions
} from './comments-graphql';

export class Comments extends Component {
    static defaultProps = {
        data: {}
    }

    constructor(props) {
        super(props);
    }

    componentDidUpdate() {
        this.stopPolling(true);
    }

    componentWillUnmount() {
        this.stopPolling(false);
    }

    stopPolling = (stopOnlyOnError) => {
        const {data: {error, stopPolling}} = this.props;
        if ((!stopOnlyOnError || !!error) && stopPolling) {
            stopPolling();
        }
    }

    startPolling = () => {
        /* istanbul ignore next */
        const {data} = this.props;
        /* istanbul ignore next */
        setTimeout(() => {
            data.startPolling({pollInterval: POLL_INTERVAL});
        }, 250);
    }

    render() {
        const {
            boardId,
            data: {
                error,
                loading,
                stopPolling,
                localizedUnitNotes: unitNotes
            },
            endDate,
            langError,
            listingId,
            locale,
            startDate,
            timezone
        } = this.props;

        const comments = unitNotes && unitNotes.unitNotes;

        return (
            <React.Fragment>
                <AddComment
                    boardId={boardId}
                    endDate={endDate}
                    listingId={listingId}
                    startPolling={this.startPolling}
                    stopPolling={stopPolling}
                    locale={locale}
                    startDate={startDate}
                    timezone={timezone}
                />
                {error && (!comments || !comments.length) &&
                    <div className="flex flex-space-around text-muted">
                        <SVGIcon className="text-danger" markup={ALERT_WARNING__16} />
                        {langError}
                    </div>
                }
                <CommentsList
                    boardId={boardId}
                    comments={comments}
                    error={error}
                    loading={!error && loading}
                    listingId={listingId}
                    pollInterval={POLL_INTERVAL}
                    startPolling={this.startPolling}
                    stopPolling={stopPolling}
                />
            </React.Fragment>
        );
    }
}

export default compose(
    withAuth,
    connect(mapStateToProps),
    graphql(GET_NOTES, {options: pollingOptions}),
    withTranslationsAsProps({
        'tripboards.error': 'langError'
    })
)(Comments);



// WEBPACK FOOTER //
// ./src/universal/tripboard/comments/components/comments.js